var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header'),_c('main',[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card-box"},[_c('router-view',{attrs:{"name":"main"}})],1)])]),_c('form-modal'),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }